import { render, staticRenderFns } from "./nodedetail.vue?vue&type=template&id=f78013ba&"
import script from "./nodedetail.vue?vue&type=script&lang=js&"
export * from "./nodedetail.vue?vue&type=script&lang=js&"
import style0 from "./nodedetail.vue?vue&type=style&index=0&id=f78013ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports